import { BehaviorSubject } from 'rxjs';

import { IDisposable } from './disposable.interface';
import { NotifyPropertyChanged } from './notify-property-changed.base';
import { IDynamicContextBindings, ObservableMembers } from '../../types/dynamic-context.interface';

export class ManagedDynamicContextBindings
  extends NotifyPropertyChanged<IDynamicContextBindings>
  implements IDynamicContextBindings, Readonly<ObservableMembers<IDynamicContextBindings>>, IDisposable
{
  private readonly _actionable = new BehaviorSubject<IDynamicContextBindings['actionable']>(undefined);
  private readonly _readable = new BehaviorSubject<IDynamicContextBindings['readable']>(undefined);
  private readonly _editable = new BehaviorSubject<IDynamicContextBindings['editable']>(undefined);
  private readonly _errors = new BehaviorSubject<IDynamicContextBindings['errors']>(undefined);

  readonly actionable$ = this._actionable.asObservable();
  get actionable() {
    return this._actionable.value;
  }
  set actionable(value) {
    if (value !== this._actionable.value) {
      this._actionable.next(value);
      this.notifyPropertyChanged('actionable');
    }
  }

  readonly readable$ = this._readable.asObservable();
  get readable() {
    return this._readable.value;
  }
  set readable(value) {
    if (value !== this._readable.value) {
      this._readable.next(value);
      this.notifyPropertyChanged('readable');
    }
  }

  readonly editable$ = this._editable.asObservable();
  get editable() {
    return this._editable.value;
  }
  set editable(value) {
    if (value !== this._editable.value) {
      this._editable.next(value);
      this.notifyPropertyChanged('editable');
    }
  }

  readonly errors$ = this._errors.asObservable();
  get errors() {
    return this._errors.value;
  }
  set errors(value) {
    if (value !== this._errors.value) {
      this._errors.next(value);
      this.notifyPropertyChanged('errors');
    }
  }

  dispose() {
    super.dispose();

    this._actionable.complete();
    this._readable.complete();
    this._editable.complete();
    this._errors.complete();
  }
}
